import React, { useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { CartProvider } from './context/CartContext';
import { LangProvider } from './context/LangContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Cart from './components/Cart';
import Home from './pages/Home';
import ProductDetail from './pages/ProductDetail';
import CategoryPage from './pages/CategoryPage';
import CheckoutPage from './pages/CheckoutPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import LegalPage from './pages/LegalPage';
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import './App.css';

function App() {
  const [cartOpen, setCartOpen] = useState(false);

  return (
    <LangProvider>
      <CartProvider>
        <BrowserRouter>
          <div className="app">
            <Routes>
              {/* Admin routes — no public navbar/footer */}
              <Route path="/admin/login"     element={<AdminLogin />} />
              <Route path="/admin/dashboard" element={<AdminDashboard />} />

              {/* Public routes */}
              <Route path="*" element={
                <>
                  <Navbar onCartOpen={() => setCartOpen(true)} />
                  <Routes>
                    <Route path="/"                   element={<Home />} />
                    <Route path="/product/:id"        element={<ProductDetail />} />
                    <Route path="/category/:cat"      element={<CategoryPage />} />
                    <Route path="/checkout"           element={<CheckoutPage />} />
                    <Route path="/about"              element={<AboutPage />} />
                    <Route path="/contact"            element={<ContactPage />} />
                    <Route path="/legal/:slug"        element={<LegalPage />} />
                  </Routes>
                  <Footer />
                  <Cart isOpen={cartOpen} onClose={() => setCartOpen(false)} />
                </>
              } />
            </Routes>
          </div>
        </BrowserRouter>
      </CartProvider>
    </LangProvider>
  );
}

export default App;
